import axios from 'axios'
import { handleApiError } from '@/utils/apiHelpers'

export default {
    getCarReservations({ commit }, payload = {
        query: ''
    } ) {
        return axios
            .get(`/reservations/car-reservations${payload.query}`)
            .then(response => {
                commit('GET_CAR_RESERVATIONS_SUCCESS', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie rezerwacji nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getCarReservation(context, carReservationId) {
        return axios
            .get(`/reservations/car-reservations/${carReservationId}`)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, `Pobranie danych do rezerwacji ${carReservationId} nie powiodło się.`)

                return Promise.reject(error)
            })
    },
    saveCarReservation({ commit }, carReservationData) {
        return axios
            .post('/reservations/car-reservations', carReservationData)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Rezerwacja została dodana.'
                }, {root: true})

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Dodanie rezerwacji nie powiodło się.')

                return Promise.reject(error)
            })
    },
    updateCarReservation({ commit }, carReservationData) {
        return axios
            .put(`/reservations/car-reservations/${carReservationData.id}`, carReservationData)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Rezerwacja została zedytowana.'
                }, {root: true})

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Edycja rezerwacji nie powiodła się.')

                return Promise.reject(error)
            })
    },
    deleteCarReservation({ commit }, carReservationData) {
        return axios
            .delete(`/reservations/car-reservations/${carReservationData.id}`, carReservationData)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Rezerwacja została usunięta.'
                }, {root: true})

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Usunięcie rezerwacji nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getCarReservationsStatuses({ commit }) {
        return axios
            .get('/reservations/car-reservations/dicts/reservation-status')
            .then(response => {
                commit('GET_CAR_RESERVATIONS_STATUSES_SUCCESS', response.data.results)

                return Promise.resolve(response.data)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie statusów nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getCarReservationsTypes({ commit }) {
        return axios
            .get('/reservations/dicts/car-type')
            .then(response => {
                commit('GET_CAR_RESERVATIONS_TYPES_SUCCESS', response.data.results)

                return Promise.resolve(response.data)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie samochodów nie powiodło się.')

                return Promise.reject(error)
            })
    },
    clearCarReservations({ commit }) {
        commit('CLEAR_CAR_RESERVATIONS')
    },
}